import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import { TextArea } from '../../components/Inputs/TextArea'
import Button from '../../components/General/Button'
import { IFoodTable } from 'safe'

export const FoodTableForm: React.FC<FoodTableFormProps> = ({
  onSubmit,
  onClose,
  useType,
  isLoading,
  defaultValues,
}) => {
  const form = useForm<IFormFoodTable>({
    defaultValues: {
      name: defaultValues?.name || '',
      description: defaultValues?.description || '',
    },
  })

  return (
    <Form classes="grid grid-cols-12 gap-4" form={form} onSubmit={onSubmit}>
      <div className="col-span-12">
        <h1 className="text-2xl font-bold">
          {useType === 'watch' ? 'Ver Mesa' : useType === 'edit' ? 'Editar Mesa' : 'Crear Mesa'}
        </h1>
      </div>

      <FormItem
        name="name"
        rules={{ required: 'Es necesario un nombre' }}
        classes="col-span-12"
      >
        <InputText label="Nombre" disableInput={useType === 'watch'} />
      </FormItem>

      <FormItem
        name="description"
        rules={{ required: 'Es necesario una descripción' }}
        classes="col-span-12"
      >
        <TextArea label="Descripción" disableInput={useType === 'watch'} />
      </FormItem>

      {useType !== 'watch' && (
        <div className="flex col-span-12 gap-3">
          <Button
            type="outline"
            classes="w-1/2"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>

          <Button
            type="primary"
            classes="w-1/2"
            htmlType="submit"
            loading={isLoading}
            disabled={isLoading}
          >
            {useType === 'create' ? 'Añadir' : 'Guardar cambios'}
          </Button>
        </div>
      )}
    </Form>
  )
}

interface FoodTableFormProps {
  onSubmit: (data: IFormFoodTable) => void
  onClose: () => void
  useType?: 'create' | 'edit' | 'watch'
  isLoading?: boolean
  defaultValues?: IFoodTable
}

export interface IFormFoodTable {
  name: string
  description: string
}
